var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择游戏组"
                  },
                  model: {
                    value: _vm.paramsData.game_group_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "game_group_id", $$v)
                    },
                    expression: "paramsData.game_group_id"
                  }
                },
                _vm._l(_vm.gameGroupList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.group_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", filterable: "", placeholder: "母包" },
                  model: {
                    value: _vm.paramsData.original_package_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "original_package_id", $$v)
                    },
                    expression: "paramsData.original_package_id"
                  }
                },
                _vm._l(_vm.originPkgList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.package_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "母包类型"
                  },
                  model: {
                    value: _vm.paramsData.original_package_type_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "original_package_type_id", $$v)
                    },
                    expression: "paramsData.original_package_type_id"
                  }
                },
                _vm._l(_vm.originPkgTypeList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.type_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择是否定时发送", clearable: "" },
                  model: {
                    value: _vm.paramsData.is_delay,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_delay", $$v)
                    },
                    expression: "paramsData.is_delay"
                  }
                },
                _vm._l(_vm.timing, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择打包状态", clearable: "" },
                  model: {
                    value: _vm.paramsData.status,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "status", $$v)
                    },
                    expression: "paramsData.status"
                  }
                },
                _vm._l(_vm.statusList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.packageItem.init()
                    }
                  }
                },
                [_vm._v("新增")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", disabled: !_vm.delIds.length },
                  on: {
                    click: function($event) {
                      return _vm.del(_vm.delIds)
                    }
                  }
                },
                [_vm._v("批量删除")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              label: "任务ID",
              width: "60px",
              type: "selection",
              selectable: _vm.selectable
            }
          }),
          _c("el-table-column", { attrs: { prop: "id", label: "ID" } }),
          _c("el-table-column", {
            attrs: { prop: "game_group_id", label: "游戏组ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "task_name", label: "任务名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "game_group_name", label: "游戏组名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "original_package_id", label: "母包ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "original_package_name", label: "母包名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "sub_package_path", label: "包地址" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.sub_package_path
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              "popper-class": "atooltip",
                              placement: "top",
                              effect: "light"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "content",
                                attrs: { slot: "content" },
                                on: {
                                  click: function($event) {
                                    return _vm.$utils.capy(row.sub_package_path)
                                  }
                                },
                                slot: "content"
                              },
                              [_vm._v(_vm._s(row.sub_package_path))]
                            ),
                            _c("div", { staticClass: "path" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.sub_package_path
                                      ? row.sub_package_path
                                      : "/"
                                  ) +
                                  " "
                              )
                            ])
                          ]
                        )
                      : _c("div", [_vm._v("/")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "original_package_type_id", label: "母包类型ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "original_package_type_name", label: "母包类型名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "params", label: "参数查看" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "viewColor",
                        on: {
                          click: function($event) {
                            return _vm.watchParams(row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "打包状态", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0 ? _c("div", [_vm._v("未开始")]) : _vm._e(),
                    row.status == 1
                      ? _c("div", { staticClass: "statusTag3" }, [
                          _vm._v("打包中")
                        ])
                      : _vm._e(),
                    row.status == 2
                      ? _c("div", { staticClass: "statusTag2" }, [
                          _vm._v("打包成功")
                        ])
                      : _vm._e(),
                    row.status == 3
                      ? _c(
                          "div",
                          { staticClass: "statusTag1" },
                          [
                            _vm._v("打包失败 "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: { content: row.result, placement: "top" }
                              },
                              [_c("i", { staticClass: "el-icon-question" })]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    row.status == 4
                      ? _c("div", [_vm._v("定时打包未开始")])
                      : _vm._e(),
                    row.status == 5 ? _c("div", [_vm._v("预备打包")]) : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "created_at", sortable: "", label: "打包时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "admin_name", label: "打包人" }
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "220px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0 || row.status == 4
                      ? _c(
                          "el-button",
                          {
                            staticClass: "controlsBtn",
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.$refs.packageItem.init(row)
                              }
                            }
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    row.status == 0 || row.status == 4
                      ? _c(
                          "el-button",
                          {
                            staticClass: "controlsBtn",
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.del([row])
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    row.status == 0 || row.status == 4 || row.status == 5
                      ? _c(
                          "el-button",
                          {
                            staticClass: "controlsBtn",
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.pkgStart(row.id)
                              }
                            }
                          },
                          [_vm._v("开始任务")]
                        )
                      : _vm._e(),
                    row.status == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "controlsBtn",
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.downLoad(row.sub_package_path)
                              }
                            }
                          },
                          [_vm._v(" 下载 ")]
                        )
                      : _vm._e(),
                    row.status == 3
                      ? _c(
                          "el-button",
                          {
                            staticClass: "controlsBtn",
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.pkgStart(row.id)
                              }
                            }
                          },
                          [_vm._v("重试")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "controlsBtn",
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.packageItem.init(row, true)
                          }
                        }
                      },
                      [_vm._v("复制")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": _vm.paramsData.page_size
            },
            on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
          })
        : _vm._e(),
      _c("packageItem", {
        ref: "packageItem",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("parameterAllDataPopup", { ref: "parameterAllDataPopup" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }